import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import PartyMappingViewForm from './PartyMappingViewForm'
import PartyMappingAddForm from './PartyMappingAddForm'
import PartyMappingEditForm from './PartyMappingEditForm'
import Namespace from 'src/constants/locale/Namespace'
import PartyMappingKeys from 'src/constants/locale/key/PartyMapping'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      UiComponentKeys,
    },
  },
} = constants

const { CngTabs } = components

function AddPage({ history, showNotification }) {
  const [lockedOnFirstTab, setLockedOnFirstTab] = useState(true)
  const [partyMappingId, setPartyMappingId] = useState('')
  const { translate } = useTranslation([
    Namespace.PARTY_MAPPING,
    Namespace.UI_COMPONENT
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let partyMapping = translate(
      Namespace.PARTY_MAPPING,
      PartyMappingKeys.TITLE
    )
    let tabLockedMessage = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Tabs.PLEASE_SUBMIT_FIRST,
      {
        title: partyMapping
      }
    )

    return {
      partyMapping,
      tabLockedMessage
    }
  }

  function makePartyMappingForm() {
    if (partyMappingId === '') {
      return (
        <PartyMappingAddForm
          history={history}
          showNotification={showNotification}
          onPostSubmitSuccess={(datum) => {
            setPartyMappingId(datum.id)
            setLockedOnFirstTab(false)
          }}
        />
      )
    } else {
      return (
        <PartyMappingEditForm
          showNotification={showNotification}
          id={partyMappingId}
        />
      )
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <PartyMappingViewForm
              showNotification={showNotification}
              id={partyMappingId}
            />
          </Container>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.partyMapping,
              tabContent: makePartyMappingForm()
            },
          ]}
          lockedOnFirstTab={lockedOnFirstTab}
          tabLockedMessage={translatedTextsObject.tabLockedMessage}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage